import React, { useState, useContext, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { useSearchParams } from 'react-router-dom';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { EventContext } from '../../../contexts/Event';
import { weekdaysIndex, getTimeZoneDateStart, getTimeZoneDateEnd } from '../../../helpers/Util';

export default function EventCalendar() {
  const { event } = useContext(EventContext);

  const [currentDate, setCurrentDate] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    setCurrentDate(null);

    const date = searchParams.get('eventDate');

    if (date) {
      setCurrentDate(
        new Date(date).toLocaleString('en', {
          timeZone: 'Europe/Lisbon'
        })
      );
    }
  }, [searchParams]);

  const weekdaysDisabled = (date) => {
    const weekday = date.day();
    let weekdays = [];

    if (event.calendar.recurrence.frequency === 'weekly') {
      weekdays = event.calendar.recurrence.weekdays.map((weekday) => weekdaysIndex[weekday]);
      return !weekdays.includes(weekday);
    }

    return !weekdays;
  };

  const startDateFn = () => getTimeZoneDateStart({ date: event.calendar.schedule[0].start });
  const endDateFn = () => getTimeZoneDateEnd({ date: event.calendar.schedule[0].end });

  // TODO: Colocar essa função no helper
  const updateSearchParams = (key, value, remove) => {
    const params = new URL(document.location).searchParams;

    const updatedSearchParams = new URLSearchParams(params.toString());

    if (remove) {
      updatedSearchParams.delete(key);
    } else {
      updatedSearchParams.set(key, value);
    }
    return updatedSearchParams.toString();
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Typography variant="h6" gutterBottom>
        Event Date
      </Typography>
      <DatePicker
        label="Event Date"
        shouldDisableDate={weekdaysDisabled}
        minDate={startDateFn()}
        maxDate={endDateFn()}
        value={currentDate || null}
        showToolbar={false}
        actionBar={false}
        onChange={(newCurrentDate) => {
          setCurrentDate(newCurrentDate);

          if (newCurrentDate?.isValid()) {
            const formattedDate = newCurrentDate
              .set('hour', 0)
              .set('minute', 0)
              .set('second', 0)
              .set('millisecond', 0)
              .tz('Europe/Lisbon', true)
              .toISOString();

            setSearchParams(updateSearchParams('eventDate', formattedDate));
          } else if (newCurrentDate === null) {
            setSearchParams(updateSearchParams('eventDate', '', true));
          }
        }}
        componentsProps={{
          actionBar: {
            actions: ['cancel']
          }
        }}
        renderInput={(params) => (
          <TextField fullWidth helperText={params?.inputProps?.placeholder} {...params} />
        )}
      />
    </LocalizationProvider>
  );
}
